export default "__VITE_ASSET__Q_RmWPO4__"